import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Col,
  Container,
  Row,
  Badge,
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody,
} from 'reactstrap';
import DataTable from '../../shared/components/DataTable';
import {
  filter,
  remove,
} from '../../redux/actions/materiaPeriodoActions';
import Confirm from '../../shared/components/Confirm';
import { createErrorMessage, createSuccessMessage } from '../../helpers/notification';

class MateriaPeriodoContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 25,
      totalItemsCount: 0,
      loading: true,
      items: [],
      filters: { id: 10 },
    };
    this.columns = [
      { key: 'id', name: '#', width: '85px' },
      { key: 'anho', name: 'Periodo', width: '85px' },
      { key: 'malla', name: 'Malla', search: true },
      {
        key: 'semestreNroOrden',
        name: 'Semestre',
        width: '85px',
        format: row => `${row.semestreNroOrden}º`,
      },
      {
        key: 'materia',
        name: 'Materia',
        search: true,
        format: ({ codigoMateria, materia, seccion }) => (
          <h5><Badge color="info">{codigoMateria}</Badge>{` ${materia} ${seccion}`}</h5>
        ),
      },
      {
        key: 'codigoMateria', name: 'Código Materia', search: true, visible: false,
      },
      {
        key: 'profesores',
        name: 'Profesor(es)',
        format: row => row.profesores.map(m => (
          <div key={`prof_${row.id}_${m.id}`}>
            {m.role === 'Asistente' ? 'Aux:' : 'Enc:'} {m.nombre} {m.apellido}
          </div>
        )),
      },
      {
        key: 'cantidadInscriptos',
        name: 'Alumnos inscriptos',
        search: false,
        className: 'text-center',
        width: '150px',
        format: row => (<h4><Badge color="info">{row.cantidadInscriptos}</Badge></h4>),
      },
      {
        key: 'tieneHorario',
        name: 'Horario',
        search: false,
        className: 'text-center',
        width: '100px',
        format: row => (
          <h4>
            <Badge
              color={row.tieneHorario ? 'success' : 'warning'}
            >
              {row.tieneHorario ? 'Si' : 'No'}
            </Badge>
          </h4>
        ),
      },
      { key: 'actions', name: 'Accion', width: '85px' },
    ];
    this.actions = [
      {
        key: 'edit',
        icon: <span className="fa fa-edit" title="Editar" />,
        callback: (record) => {
          this.edit(record);
        },
      },
      {
        key: 'delete',
        icon: row => (
          <>
            <span id={`UncontrolledPopover${row.id}`} className="fa fa-trash" title="Borrar" />
            <UncontrolledPopover
              trigger="legacy"
              placement="left"
              target={`UncontrolledPopover${row.id}`}
              className="info"
              disabled={!row.cantidadInscriptos}
            >
              <PopoverHeader>No se puede borrar la materia</PopoverHeader>
              <PopoverBody>Hay alumnos inscriptos en la materia.</PopoverBody>
            </UncontrolledPopover>
          </>
        ),
        callback: (record) => {
          if (!record.cantidadInscriptos) {
            this.handleDeleteAction(record);
          }
        },
      },
    ];
  }

  componentDidMount() {
    const { page, pageSize } = this.state;
    this.updateExamsTable(page, pageSize);
  }

  updateExamsTable = (page, pageSize, filters) => {
    this.setState({
      loading: true,
      page,
      pageSize,
      filters: filters || {},
    });
    filter({
      pageInfo: {
        page,
        pageSize,
        filters,
      },
      onSuccess: ({ items, totalItemsCount }) => {
        this.setState({
          loading: false,
          items,
          totalItemsCount,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de materias por periodo');
      },
    });
  }

  handleDeleteAction = (record) => {
    const name = `${record.materia}`;
    Confirm({
      title: 'Borrar materia por periodo',
      question: `Estás seguro que deseas eliminar esta materia "${name}" del periodo?`,
      yesLabel: 'Si, Borrar',
      noLabel: 'No, Volver',
      onConfirm: () => {
        remove(record.id,
          {
            onSuccess: () => {
              createSuccessMessage('Materia borrado exitosamente');
              const { page, pageSize } = this.state;
              this.updateExamsTable(page, pageSize);
            },
            onError: (error) => {
              if (error && error.status === 404) {
                createErrorMessage('La matria para este periodo no existe');
              } else {
                createErrorMessage('Error al intentar borrar materia del periodo');
              }
            },
          });
      },
    });
  };

  edit = (record) => {
    const { history } = this.props;
    history.push(`/pages/subjects-periods/edit/${record.id}`);
  };

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updateExamsTable(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateExamsTable(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updateExamsTable(1, pageSize, {});
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  render() {
    const {
      loading,
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Lista de materias por periodo</h3>
            <div className="card__title">
              <Link className="btn btn-primary" to="/pages/subjects-periods/new">
                <i className="fa fa-plus" /> Agregar nueva materia a periodo
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          {loading ? <Col md={12}><h3 className="page-subhead subhead">Cargando...</h3></Col>
            : (
              <DataTable
                title="Listado de todas las materias por periodo"
                columns={this.columns}
                items={items}
                onChangePage={this.onChangePage}
                page={page}
                pageSize={pageSize}
                totalItemsCount={totalItemsCount}
                getGridActions={key => this.getGridActions(key)}
                onSubmit={this.onDataTableSubmit}
                onClearFilters={this.onDataTableClearFilters}
                initialValues={filters}
                enableReinitialize
              />
            )
          }
        </Row>
      </Container>
    );
  }
}

export default withRouter(MateriaPeriodoContainer);
